
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 23.25v-21a1.5 1.5 0 0 0-1.5-1.5h-15A1.5 1.5 0 0 0 3 2.25v21l3-3 3 3 3-3 3 3 3-3ZM6 6h6m-6 4.5h6M6 15h6","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M17.625 5.25a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375m0 4.5a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375m0 4.5a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    